import Typography from '../../../../../typography';
import React from 'react';
import { useTheme } from 'styled-components';

interface ListDataTitleDescProps {
  title: React.ReactNode;
  description?: React.ReactNode;
}

const ListDataTitleDesc: React.FunctionComponent<ListDataTitleDescProps> = ({
  description,
  title,
}) => {
  const theme = useTheme();

  return (
    <>
      <Typography as="div" display="h5" variant="strong" style={{ color: theme.color.tint.action }}>
        {title}
      </Typography>
      {description ? (
        <Typography
          as="div"
          display="captionLarge"
          variant="default"
          style={{ color: theme.color.tint.tertiary, marginTop: 4 }}
        >
          {description}
        </Typography>
      ) : null}
    </>
  );
};

export default ListDataTitleDesc;
